import EventBus, { Event, Handler, Unsubscriber } from '@/core/event-bus';
import PlayerStateRepository, { PlayerState, StateHandler, SubtitleTrack } from './player-state';

const PortalIds: Record<string, string> = {
    SIDEBAR_NOTIFICATION: 'side-bar-notification'
};

export default class VideoPlayerApi {
    constructor(
        private eventBus: EventBus,
        private playerStateRepo: PlayerStateRepository,
        private _instanceId: string
    ) { }

    // player actions

    public play(): void {
        this.eventBus.emit(Event.play);
    }

    public pause(): void {
        console.debug('[PlayerApi] pause');
        this.eventBus.emit(Event.pause);
    }

    public enterFullScreen(): void {
        this.eventBus.emit(Event.enterFullScreen);
    }

    public exitFullScreen(): void {
        this.eventBus.emit(Event.exitFullScreen);
    }

    public enterNativeFullScreen(): void {
        this.eventBus.emit(Event.enterNativeFullScreen);
    }

    public exitNativeFullScreen(): void {
        this.eventBus.emit(Event.exitNativeFullScreen);
    }

    public seek(seconds: number): void {
        this.eventBus.emit(Event.seek, { seconds });
    }

    public mute(): void {
        this.eventBus.emit(Event.mute);
    }

    public unmute(): void {
        this.eventBus.emit(Event.unmute);
    }

    public changeVolume(volume: number): void {
        this.eventBus.emit(Event.changeVolume, { volume });
    }

    public alwaysShowControlBar(alwaysShowControlBar: boolean): void {
        this.eventBus.emit(Event.alwaysShowControlBar, { alwaysShowControlBar });
    }

    public selectSubtitleTrack(track: SubtitleTrack): void {
        this.eventBus.emit(Event.selectSubtitleTrack, { track });
    }

    public disableSubtitles(): void {
        this.eventBus.emit(Event.disableSubtitles);
    }

    public disableNotifications(disable: boolean): void {
        this.eventBus.emit(Event.disableNotifications, disable);
    }

    public errorNotification(message: string, show = true): void {
        this.eventBus.emit(
            Event.notification,
            {
                message,
                show
            },
            'errorNotification'
        );
    }

    public customAction(payload: unknown, context: string): void {
        this.eventBus.emit(Event.customAction, payload, context);
    }

    public clientAction(payload: unknown, context: string): void {
        this.eventBus.emit(Event.clientAction, payload, context);
    }

    public dispose(): void {
        this.eventBus.emit(Event.dispose);
    }

    public onStateChange(handler: StateHandler): {
        unsubscriber: Unsubscriber,
        state: PlayerState
    } {
        return this.playerStateRepo.onStateChange(handler);
    }

    public getState(): PlayerState {
        return this.playerStateRepo.state;
    }

    public onCustomAction(handler: Handler): Unsubscriber {
        return this.eventBus.on(Event.customAction, handler);
    }

    public onClientAction(handler: Handler): Unsubscriber {
        return this.eventBus.on(Event.clientAction, handler);
    }

    public onMetadataChange(handler: Handler): Unsubscriber {
        return this.eventBus.on(Event.metadata, handler);
    }

    public onSeek(handler: Handler): Unsubscriber {
        return this.eventBus.on(Event.seek, handler);
    }

    public getPortalId(type: string): string {
        return `smvp-${PortalIds[type]}-${this._instanceId}`;
    }

    public expandSidebar(context?: string): void {
        return this.playerStateRepo.setState({ isSidebarExpanded: true }, context || 'api');
    }

    public collapseSidebar(context?: string): void {
        return this.playerStateRepo.setState({ isSidebarExpanded: false }, context || 'api');
    }

    public selectLevel(id?: number): void {
        return this.eventBus.emit(Event.selectLevel, { id });
    }
}
